import { useImperativeHandle, forwardRef, useEffect } from "react"
import styles from './index.module.scss'
import { notification } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';

const BottomEventPopup = forwardRef((props, ref) => {
    const [api, contextHolder] = notification.useNotification();
    const notificationKey = 'bottomEventPopup';
    const location = useLocation();

    useImperativeHandle(ref, () => ({
        handleClick
    }))
    useEffect(() => {
        api.destroy(notificationKey);
    }, [location.pathname]);

    const handleClick = (popup, onClose) => {
        api.info({
            key: notificationKey,
            message: null,
            description: (
                <div
                    onClick={() => {
                        props.popupClick(popup);
                        api.destroy(notificationKey);
                    }}
                    className={styles.bottomEventPopupBox}
                >
                    <img src={popup?.popupImage} alt="" />
                </div>
            ),
            placement: 'bottomRight',
            closeIcon: (
                <span className={styles.modalcloseIcon}>
                    <CloseOutlined />
                </span>
            ),
            icon: <></>,
            duration: null,
            className: `${styles.bottomEventPopup} bottom-event-popup`,
            onClose: () => {
                if (onClose) onClose();
            }
        });
    };

    return (
        <>
            {contextHolder}
        </>
    )
})

export default BottomEventPopup
